import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import ProjectCard from './project-card/ProjectCard';
import './ProjectCarousel.css'; // include the styles from Embla setup

const projects = [
  {
    id: 1,
    title: 'Masters Basketball Academy',
    image: require('../../assets/mbaHome1.png'),
    tools: ['React', 'Spring Boot', 'AWS', 'MySql'],
description: `Masters Basketball Academy is a dynamic web platform built for a basketball club to manage events, members, and registrations. Users can browse upcoming tournaments, view event details like date, place, and category, and register by creating an account and making secure online payments.

The platform uses AWS Cognito for authentication and is deployed securely on AWS infrastructure. It features role-based login with different views for users and admins. Users receive confirmation via email or mobile after registering, while admins can view registered teams, player details, and manage event-related data.

A real-time dashboard and controller module is included, which can be operated across two different screens. This allows seamless updates and monitoring during live events, enhancing on-ground coordination and experience.`,

    liveLink: 'https://mastersbasketballacademy.com/',
    sourceCodeLink:'https://github.com/bibhu004/mastersBasketballAcademy/blob/main/README.md',
    fullProject: 'https://github.com/bibhu004/mastersBasketballAcademy/blob/main/README.md',
  },
  
  {
  id: 2,
  title: 'Portfolio Website',
  image: require('../../assets/portfolioHome.png'),
  tools: ['React', 'Tailwind CSS', 'AWS'],
  description:`A responsive portfolio website developed using React and styled with Tailwind CSS and custom CSS. It highlights my skills, experience, and project work in a clean, modern layout. The site is fully optimized for both desktop and mobile users.
  

  The application is hosted on AWS S3, ensuring fast load times and high availability. Navigation is smooth, and the interface is built to be user-friendly and minimal for a professional presentation.


  It includes a text block for users to send messages without needing backend support, simulating interaction. I’ve also integrated a personal AI assistant to help visitors explore the content and get quick answers.`,
  
  liveLink: 'https://bibhu.com/',
},
{
  id: 3,
  title: 'AI Personal Assistant',
  image: require('../../assets/AiAgentHome.png'),
  tools: ['n8n', 'PineCone', 'AWS', 'OpenAI API'],
  description:
    `I created a Personal AI Assistant hosted on AWS EC2 using n8n workflows, OpenAI, and Pinecone. It continuously learns from updates in the knowledge base, where new files added to Google Drive are processed into vector embeddings and stored for future reference.


    The assistant can understand user queries through a chatbot interface, fetch the most relevant information from its knowledge base, and respond in a clear, conversational manner. This makes it capable of providing context-aware answers and insights tailored to the data it has learned.


    With this setup, the Personal AI Assistant acts as an intelligent knowledge companion, combining automated learning with interactive Q&A to support tasks like document search, information retrieval, and decision-making.`,
  
  liveLink: 'https://bibhu.com/ai-assistant',
},
  {
  id: 4,
  title: 'OTT Billing System',
  image: require('../../assets/oneStopHome.png'),
  tools: ['Spring Boot', 'Angular', 'MySQL', 'AWS'],
  description:
    `A third-party billing platform designed for OTT services, enabling users to create postpaid family accounts and subscribe to bundled offers. Built with Angular for the frontend and Spring Boot for the backend, the system ensures a smooth and responsive user experience.
    
    


    Users can log in, specify the number of family members, and receive tailored subscription bundles from multiple OTT platforms at discounted prices. The recommendation engine dynamically suggests plans based on the input, helping users save more with customized packages.
    
    


    The application is deployed on AWS EC2 and uses AWS RDS for MySQL database storage. It provides secure, scalable access and maintains high performance for billing logic, account management, and offer calculation.`,
  
  liveLink: 'https://bibhu.com/ott-billing',
},

];

const Project = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  

  return (
    <div className="project-container min-h-[85vh]  bg-gradient-to-b from-blue-100 to-gray-200">

      <div className="prject-heading pt-2 pb-4">
        <h1 className="text-4xl font-bold text-center">Projects</h1>
        <div className="w-20 h-1 bg-blue-600 mx-auto mt-2 rounded-full"></div>
      </div>


      <div className="embla mx-auto w-1/2 " ref={emblaRef}>
        <div className="embla__container ">
          {projects.map((project, index) => (
            <div className="embla__slide px-6 w-full h-[80vh] rounded-3xl" key={index}>
              <ProjectCard project={project} />
            </div>
          ))}
        </div>

        <button className="embla__prev" onClick={scrollPrev}>
          ❮
        </button>
        <button className="embla__next" onClick={scrollNext}>
          ❯
        </button>
       
      </div>
    </div>
  );
};

export default Project;
